const wowApp = require('angular').module('wowApp.common');

const { FrontendManagementService } = require('./frontend-management.service');

wowApp.service('FrontendManagementService', FrontendManagementService);



// WEBPACK FOOTER //
// ./src/common/frontendmanagement/index.js